import React from "react";
import { Link } from "react-router-dom";

export const OBJECTIFS_TEMPORELS_COLUMNS = (filteredUser) => [
  {
    Header: "Référence dossier",
    accessor: "reference",
    Cell: (cellInfo) => {
      return (
        <Link to={`/projet/${cellInfo.row.original.id}`}>
          {cellInfo.row.original.reference}
        </Link>
      );
    },
  },
  {
    Header: "Nom client",
    accessor: "niceNames",
    Cell: (cellInfo) => {
      return (
        <Link to={`/client/${cellInfo.row.original.client.id}`}>
          {cellInfo.row.original.client.niceNames}
        </Link>
      );
    },
  },
  {
    Header: "Collaborateur",
    Cell: (cellInfo) => filteredUser.niceNames,
  },
  {
    Header: "Rôle",
    Cell: (cellInfo) => filteredUser.highestRole.replace("ROLE_", ""),
  },
  {
    Header: "Temps prévisionnel",
    accessor: "userEstimatedHours",
    Cell: (cellInfo) => {
      const heures = Math.floor(cellInfo.row.original.userEstimatedHours);
      const decimalPart = cellInfo.row.original.userEstimatedHours - heures;
      const minutes = Math.round(decimalPart * 60);

      if (heures === 0) {
        return (
          <div>
            {minutes < 10 ? "0" : ""}
            {minutes} min
          </div>
        );
      } else {
        return (
          <div>
            {heures}h{minutes < 10 ? "0" : ""}
            {minutes}
          </div>
        );
      }
    },
  },
  {
    Header: "Temps réel",
    accessor: "userEffectiveHours",
    Cell: (cellInfo) => {
      const heures = Math.floor(cellInfo.row.original.userEffectiveHours);
      const decimalPart = cellInfo.row.original.userEffectiveHours - heures;
      const minutes = Math.round(decimalPart * 60);

      if (heures === 0) {
        return (
          <div>
            {minutes < 10 ? "0" : ""}
            {minutes} min
          </div>
        );
      } else {
        return (
          <div>
            {heures}h{minutes < 10 ? "0" : ""}
            {minutes}
          </div>
        );
      }
    },
  },
  {
    Header: "Écart",
    accessor: "Ecart",
    Cell: (cellInfo) => {
      let ecart =
        cellInfo.row.original.userEstimatedHours -
        cellInfo.row.original.userEffectiveHours;
      const heures = Math.floor(ecart);
      const decimalPart = ecart - heures;
      const minutes = Math.round(decimalPart * 60);
      if (heures === 0) {
        return <div>{minutes} min</div>;
      } else {
        return (
          <div>
            {heures}h{minutes < 10 ? "0" : ""}
            {minutes}
          </div>
        );
      }
    },
  },
  {
    Header: "Coût réel",
    accessor: "Coût réel",
    Cell: (cellInfo) => {
      return (
        <div>
          {(
            cellInfo.row.original.userEffectiveHours *
              cellInfo.row.original.ingAff?.rateH || 0
          ).toFixed(2)}{" "}
          €
        </div>
      );
    },
  },
  {
    Header: "Taux marge",
    accessor: "TauxMarge",
    Cell: (cellInfo) => {
      let tauxMarge =
        ((cellInfo.row.original.userEstimatedHours -
          cellInfo.row.original.userEffectiveHours) /
          cellInfo.row.original.userEstimatedHours) *
        100;
      return <div>{tauxMarge ? tauxMarge.toFixed(2) : "0.00"} %</div>;
    },
  },
];
